<template>
    <div v-if="show" id="subcontainer-alert" :class="[[state], store.getAlertType() == 'success' ? 'bg-green-success' : store.getAlertType() == 'information' ? 'bg-yellow-information' : store.getAlertType() == 'error' ? 'bg-red-error' : '']" class="transition-opacity duration-130 ease-in-out fixed z-50 px-third py-special rounded-smoth mb-special mt-special w-fit ml-special bottom-modal-desktop max-md:bottom-alert-mobile">
        <div id="alert" class="flex">
            <div id="symbol">
                <span v-if="store.getAlertType() == 'information'" class="w-5 flex">
                    <font-awesome-icon icon="circle-info" class="text-primary-text h-full"/>
                </span>
                <span v-if="store.getAlertType() == 'success'" class="w-5 flex">
                    <font-awesome-icon icon="circle-check" class="text-green-success-text h-full"/>
                </span>
                <span v-if="store.getAlertType() == 'error'" class="w-5 flex">
                    <font-awesome-icon icon="circle-exclamation" class="text-red-error-text h-full"/>
                </span>
            </div>
            <div id="text" class="flex flex-wrap content-center ml-special">
                <span :class="[store.getAlertType() == 'success' ? 'text-green-success-text' : store.getAlertType() == 'information' ? 'text-primary-text' : store.getAlertType() == 'error' ? 'text-red-error-text' : '']" class="font-bloggerB text-secondary-desktop">{{ store.getAlertMsg() }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { generalStore } from '@/stores';
import { watchEffect, ref } from 'vue';

const store = generalStore();
let show = ref(false);
let state = ref('inactive');

watchEffect(() => {
    if (store.getAlertState() == 'inactive-alert') {
        state.value = 'inactive'
        setTimeout(() => {
            show.value = false
        }, 900)
    } else {
        show.value = true
        setTimeout(() => {
            state.value = 'active'
        }, 100)
    }
})
</script>